import { MinLength, Length } from 'class-validator';

export class SolicitudCorrespValidate {
    @Length(1, 100)
    Nombre: string;
    @Length(1, 60)
    Direccion: string;
    @Length(1, 40)
    Poblacion: string;
    @Length(1, 20)
    Provincia: string;
    @Length(5, 5)
    Cpostal: string;
    @MinLength(1)
    Nacion: string;
}



// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/SolicitudCorrespValidate.entity..ts